import { render, staticRenderFns } from "./supplier-query.vue?vue&type=template&id=54b7319e&"
import script from "./supplier-query.vue?vue&type=script&lang=ts&"
export * from "./supplier-query.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports